import { Component, ViewChild } from "@angular/core";
import { CardTableComponent } from "src/app/components/cards/card-table/card-table.component";
import { CrudComponent } from "src/app/components/shared/cruds/crud.component";
import { Condition } from "src/app/models/custom-types";
import { UsuarioSimpleDto } from "src/app/models/dto/usuario-simple.dto";
import { FilterEvent } from "src/app/models/filter";
import { ListColumn } from "src/app/models/list-columns.model";
import { AlertasSwalService } from "src/app/services/alerts.service";
import { LayoutsService } from "src/app/services/layouts.service";
import { Filter } from "src/app/shared/classes/filter";
import { SweetAlertOptions } from "sweetalert2";
import { UsersService } from "./users.service";
import { UsersDrawerForm } from "./drawer-form/drawer-form.component";
import { DrawerService } from "src/app/services/drawer.service";
import { PermisosService } from "src/app/services/permisos.service";
import { PasswordModal } from "./pass-modal/pass-modal.component";
import { MatDialog } from "@angular/material/dialog";

@Component({
  selector: "app-users",
  templateUrl: "./users.component.html",
  styles: [],
})
export class UsersComponent extends CrudComponent<any> {
  columnId: string = "IdUsuario";
  public columns: ListColumn[] = [
    {
      name: "Usuario",
      property: "Usuario",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "Correo",
      property: "Correo",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "Iniciales",
      property: "Iniciales",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "actions",
      property: "actions",
      visible: true,
      isModelProperty: false,
    },
  ];
  @ViewChild(CardTableComponent, { static: true })
  public tableComp: CardTableComponent;
  realdata: UsuarioSimpleDto[];
  askRemoveConfig: SweetAlertOptions = {
    title: "Seguro que quieres eliminar este registro?",
    text: "Esta accion es irreversible!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Si",
    cancelButtonText: "No",
  };

  constructor(
    public service: UsersService,
    private layoutService: LayoutsService,
    public alertsServ: AlertasSwalService,
    public drawer: DrawerService,

    private dialog: MatDialog,
    private permisosServ: PermisosService,
  ) {
    super(service, alertsServ);
  }

  ngOnInit(): void {
    this.loadRecords();
    this.layoutService.changeHeader("Usuarios");
    this.filter = new Filter<UsuarioSimpleDto>(
      this.conditions,
      this.columns,
      true,
    );
    this.filter.setColumnActive(this.columnActive);

    if (this.permisosServ.getPermisos().includes("spcl_user_pass")) {
      this.actions.splice(1,0,{
        desc: "Cambiar contrasena",
        action: "passwordchange",
        visible: (row) => row[this.columnActive],
        icon: "fas fa-key",
        color: "text-amber-400",
      });
    }
  }

  loadRecords() {
    this.service.get().subscribe(
      (resultData) => {
        this.realdata = resultData.map((m) => {
          return { ...m, PermisosLong: m.Permisos.join(",") };
        });
        this.filter.setDataTable(this.realdata, this.tableComp);
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      },
    );
  }
  //#region Filter

  public filter: Filter<UsuarioSimpleDto>;
  public conditions: Condition<UsuarioSimpleDto> = {
    Usuario: (o, f) => (o.Usuario ?? "").toLocaleLowerCase().indexOf(f) > -1,
    Correo: (o, f) => (o.Correo ?? "").toLocaleLowerCase().indexOf(f) > -1,
    PermisosLong: (o, f) => o.PermisosLong.toLocaleLowerCase().indexOf(f) > -1,
  };

  filterdata(e: FilterEvent) {
    this.filter.filterdata(e, this.realdata, this.tableComp);
  }

  //#endregion Filter
  saveForm(e: { mode: string; value: any }) {
    if (e.mode == "create") {
      this.guardar(e.value);
    } else if (e.mode == "update") {
      this.actualizar(e.value);
    }
  }
  actionstable(e: { action: string; row: any }) {
    if (e.action == "update") {
      this.openEdit(e.row);
      // this.formulario.setUpdate(e.row);
    } else if (e.action == "activate") {
      this.activar(e.row);
    } else if (e.action == "passwordchange") {
      this.openChangePass(e.row);
    }else if (e.action == "remove") {
      this.alerts.ask(this.askRemoveConfig).then((result) => {
        if (result.isConfirmed) {
          this.eliminar(e.row);
        }
      });
    }
  }

  guardar(row: any) {
    this.service.add(row).subscribe(
      (next) => {
        this.alerts.correcta("Creado", "Accion realizada correctamente");
        this.formulario.setStanby();
        this.loadRecords();
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      },
    );
  }
  actualizar(row: any) {
    this.service.update(row).subscribe(
      (next) => {
        this.alerts.correcta("Actualizado", "Accion realizada correctamente");
        this.formulario.setStanby();
        this.loadRecords();
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      },
    );
  }
  eliminar(row: any) {
    this.service.delete(row[this.columnId]).subscribe(
      (next) => {
        this.alerts.correcta("Eliminado", "Accion realizada correctamente");
        this.loadRecords();
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      },
    );
  }
  activar(row: any) {
    this.service.activate(row[this.columnId]).subscribe(
      (next) => {
        this.alerts.correcta("Activado", "Accion realizada correctamente");
        this.loadRecords();
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      },
    );
  }

  openUser() {
    const drawerRef = this.drawer.open({
      component: UsersDrawerForm,
      data: { mode: "create", value: {} },
      classDrawer: "w-3/4",
      title: "Usuarios",
      classes: "bg-blueGray-100",
      actions: [
        {
          label: "Cancel",
          action: () => this.drawer.close(),
          buttonClass: "bg-red-600",
        },
        {
          label: "Guardar",
          action: (component: UsersDrawerForm) => component.saveOver(),
        },
      ],
    });

    drawerRef.afterClosed$.subscribe((result: any) => {
      this.saveForm(result.data);
    });
  }

  override openEdit(value: any) {
    const drawerRef = this.drawer.open({
      component: UsersDrawerForm,
      data: { mode: "update", value: value },
      classDrawer: "w-3/4",
      title: "Usuarios",
      classes: "bg-blueGray-100",
      actions: [
        {
          label: "Cancel",
          action: () => this.drawer.close(),
          buttonClass: "bg-red-600",
        },
        {
          label: "Actualizar",
          action: (component: UsersDrawerForm) => component.saveOver(),
        },
      ],
    });

    drawerRef.afterClosed$.subscribe((result: any) => {
      this.saveForm(result.data);
    });
  }
  public tableActionsCC = [
    {
      label: "Nuevo",
      icon: "plus",
      className:
        "text-xs font-bold uppercase px-3 py-2 rounded shadow hover:shadow-md bg-blueGray-600 text-white disabled:opacity-50",
      action: () => this.openUser(),
    },
  ];


    async openChangePass(row:any) {
      const result = await this.dialog
        .open(PasswordModal, {
          panelClass: ["w-full", "lg:w-1/2"],
          data: {
            usuario: row.Usuario,
          },
        })
        .afterClosed()
        .toPromise();

      if (result) {
        this.service
          .changePass({
            ...result,
            IdUsuario: row.IdUsuario,
          })
          .subscribe(
            (next) => {
              this.alerts.correcta(
                "Actualizado",
                "Accion realizada correctamente"
              );
            },
            (err) => {
              this.alerts.error("error", err.error.Message);
            }
          );
      }
    }
}
